import KeyboardArrowDownIcon from 'assets/icons/general/KeyboardArrowIcon'
import React from 'react'

function SelectInput({
    name,
    classNameDiv,
    classNameInput = "text-sm md:text-base lg:text-lg",
    label,
    required,
    options,
    disabled,
    onChange,
    onBlur,
    error,
    value,
    placeholder = "Select one..."
}) {
    return (
        <div className={`flex flex-col space-y-2 ${classNameDiv}`}>
            {label && (
                <label htmlFor={name} className='font-semibold flex text-sm md:text-base lg:text-lg'>
                    <p>{label}</p>
                    {required && (
                        <span className='text-red-500'>*</span>
                    )}
                </label>
            )}
            <div className='relative flex items-center overflow'>
                <select
                    id={name}
                    name={name}
                    className={`${classNameInput} truncate appearance-none w-full border border-app-light-grey-2 rounded-lg bg-transparent px-3 py-2 pr-6 focus:outline-none focus:border-2 focus:border-blue-500 `}
                    disabled={disabled}
                    onChange={onChange}
                    onBlur={onBlur}
                >
                    {[{ id: "", text: placeholder }, ...options]?.map((option, i) => (
                        <option selected={option?.id?.toString() === value?.toString() || option.text === value} key={i} value={option.id}>{option.text}</option>
                    ))}
                </select>
                <KeyboardArrowDownIcon
                    className="absolute right-0 mr-3 fill-black h-3 w-3"
                />
            </div>
            {error && (
                <p className='text-xs md:text-sm text-red-500'>{error}</p>
            )}
        </div>
    )
}

export default SelectInput